export default "__VITE_ASSET__D9Q1rOOV__"